module.exports = __webpack_public_path__ + "img/tien_ich_cong_viec.79929b1e.svg";